<template>
    <div class="warehouse-unit-picker-container">
        <ModalHeader :title="getString('edit_unit')" />
        <div class="units-type">
            <div class="unit-type">
                <div class="type-title">{{ getString('mass') }}</div>
                <AppButton text="kg" outline small :class="{activeUnit: currentUnit === 'kg'}" @click="$emit('chosen', 'kg')" />
                <AppButton text="g" outline small :class="{activeUnit: currentUnit === 'g'}" @click="$emit('chosen', 'g')" />
                <AppButton text="mg" outline small :class="{activeUnit: currentUnit === 'mg'}" @click="$emit('chosen', 'mg')" />
            </div>
            <div class="unit-type">
                <div class="type-title">{{ getString('volume') }}</div>
                <AppButton text="L" outline small :class="{activeUnit: currentUnit === 'L'}" @click="$emit('chosen', 'L')" />
                <AppButton text="cL" outline small :class="{activeUnit: currentUnit === 'cL'}" @click="$emit('chosen', 'cL')" />
                <AppButton text="mL" outline small :class="{activeUnit: currentUnit === 'mL'}" @click="$emit('chosen', 'mL')" />
            </div>
            <div class="unit-type">
                <div class="type-title">{{ getString('counting') }}</div>
                <AppButton :text="getString('pieces')" outline small :class="{activeUnit: currentUnit === 'pz'}" @click="$emit('chosen', 'pz')" />
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
    setup() {
        const languageStore = useLanguageStore();
        const userStore = useUserStore();
        return {
            getString: languageStore.getString,
            userStore,
        }
    },
    emits: ["chosen"],
    name: "WarehouseUnitOfMeasurePicker",
    components: {ModalHeader, AppButton},
    props: {
        currentUnit: {
            type: String,
            default: "pz"
        }
    },
}
</script>

<style scoped lang="scss">
.units-type {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;

    .unit-type {
        width: calc((100% / 3) - 12px);
        gap: 12px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        margin: 8px 0;

        .type-title {
            font-size: 14px;
            font-weight: 500;
        }

        .base-button.activeUnit {
            background-color: rgba(40, 237, 191, 0.12);
        }

        @media (max-width: 420px) {
            width: calc((100% / 2) - 12px);
        }
    }
}
</style>